import axios from "axios";
import { API_ENDPOINT } from "../../apiConstant";


export const getDocumentStatus = (token) => {
  let url = `${API_ENDPOINT}/api/get_document_status/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getCreditNavStatus = (token) => {
  let url = `${API_ENDPOINT}/api/user_details/credit_nav_status/`;
  
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};



export const eMandateWebView = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/emandate/`;
  let config = {
    headers:{
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return new Promise((resolve, reject) => {
    axios
      .get(url, config)
      .then((res) => {
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const callBackApi = (token) => {
  let url = `${API_ENDPOINT}/api/request_callback/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return new Promise((resolve, reject) => {
    axios
      .get(url, config)
      .then((res) => {
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const registerCall = (data, token) => {
  let url = `${API_ENDPOINT}/api/request_callback/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, config)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const preSignedURL = ({ s3_path, token }) => {
  let url = `${API_ENDPOINT}/api/v2/upload_to_s3/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, s3_path, config)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const uploadDocsToS3 = ({ url, formData }) => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, formData)
        .then((result) => {
          return resolve(result);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const upldateDocumentStatus = ({ updateStatus, token }) => {
  let url = `${API_ENDPOINT}/api/update_document_status/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, updateStatus, config)
        .then((response) => {
          // console.log(response);
          return resolve(response);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const postBankDetailList = ({ ifsc, token }) => {
  let url = `${API_ENDPOINT}/api/bankdetails_list/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, ifsc, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const postSalaryBasedEmployeeDetails = (data, token) => {
  let url = `${API_ENDPOINT}/api/user_details/professional_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getIndustryList = (token) => {
  let url = `${API_ENDPOINT}/api/industry_list/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};
export const postCompanyList = (token, passBody) => {
  let url = `${API_ENDPOINT}/api/company_list/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, {"company":passBody}, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const submitManualKyc = ({ jsonData, token }) => {

  let url = `${API_ENDPOINT}/api/offline_manual_kyc/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, jsonData, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const postalcode = ({ pincode, token }) => {
  let url = `${API_ENDPOINT}/api/pincode_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, pincode, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getFaqs = (token) => {
  let url = `${API_ENDPOINT}/api/faq_list/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error) => {
          if(error.response.status === 401){
            return reject (error.response.status);
          }
        });
    });
};

export const refreshToken = (data) => {
  let url = `https://api.testing.paymeindia.in/api/refresh_tokens/`;
 
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error) => {
          if(error.response.status === 401){
            return reject (error.response.status);
          }
        });
    });
};


export const getBankDetails = (token) => {
  let url = `${API_ENDPOINT}/api/user_details/bank_details/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const getProfessionalDetails = (token) => {
  let url = `${API_ENDPOINT}/api/user_details/professional_details/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const getWebViewBankUrl = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/bank_login/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getAxisUrl = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/axis_bank/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const CreditAssist = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/credit_assist/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};



export const professioanlWebView = (token, salaried_status) => {
  let url = salaried_status 
  ? `${API_ENDPOINT}/api/webview_url/professional/?salaried=true` 
  : `${API_ENDPOINT}/api/webview_url/professional/?salaried=false`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const creditcardrediraction= (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/credit_card/`; 
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const fetchOtherProducts = (token) => {
  let url = `${API_ENDPOINT}/api/general_data/other_products/`; 
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const fetchBanner = (token) => {
  let url = `${API_ENDPOINT}/api/general_data/banners/`; 
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const fetchProductsUrl = (token, productKey) => {
  let url = `${API_ENDPOINT}/api/webview_url/all_products/`; 
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  let data = {
    product: productKey, 
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config) 
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};






export const referandearndiraction= (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/new_perp/`; 
  
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};



export const mutualfundrediraction = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/lamf/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  
  return (dispatch) => {
    return axios.get(url, config) 
      .then((res) => {
        return res; 
      })
      .catch((err) => {
        throw err; 
      });
  };
};

export const goldloanrediraction = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/digital_gold/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  
  return (dispatch) => {
    return axios.get(url, config) 
      .then((res) => {
        return res; 
      })
      .catch((err) => {
        throw err; 
      });
  };
};




export const insurancerediraction = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/insurance/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  
  return (dispatch) => {
    return axios.get(url, config) 
      .then((res) => {
        return res; 
      })
      .catch((err) => {
        throw err; 
      });
  };
};






export const getWebViewEkycUrl = (token) => {
  let url = `${API_ENDPOINT}/api/v3/webview_url/payme_ekyc/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const addBankDetails = (token,data) => {
  // console.log(token, data, "addBankDetails");
  let url = `${API_ENDPOINT}/api/v2/user_details/bank_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((error) => {
          return reject (error);
         
        });
    });
};

export const getIfscCode = (token,data) => {
  let url = `${API_ENDPOINT}/api/bankdetails_list/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error) => {
          if(error.response.status === 401){
            return reject (error.response.status);
          }
        });
    });
};




export const getRedirctionSahmati = (token) => {
  let url = `${API_ENDPOINT}/api/v2/sahamati_link/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const PaymelearnSaga = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/quizzers/finance/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const PaymelearnSagaCredit = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/quizzers/credit/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


